/**
 * Mega text JavaScript
 *
 * This file defines behaviors of
 * the Mega Text block.
 */
// fix ios safari issue where all transitions pause jarringly on page leave
document
	.querySelectorAll('.mega-text .wp-block-button__link')
	?.forEach((el) => {
		// identify if we're on a touch device when a link gets touched
		el.addEventListener('touchstart', () => {
			el.dataset.touch = 'is-touch';
		});
		// if we've identified as a toch device then wait for animation finish before navigation
		el.addEventListener('click', (e) => {
			if (el.dataset.touch === 'is-touch') {
				e.preventDefault();
				setTimeout(() => {
					window.location = el.href;
				}, 600);
			}
		});
	});
